import { render, staticRenderFns } from "./FeedAlertEditTiming.vue?vue&type=template&id=61affd2c"
import script from "./FeedAlertEditTiming.vue?vue&type=script&lang=js"
export * from "./FeedAlertEditTiming.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports